import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '@/context/AuthContext';
import Layout from '@components/Layout';
import ImageUploader from '@components/ImageUploader'; // Custom ImageUploader component
import ReactQuill from 'react-quill'; // Import ReactQuill
import { toast } from 'react-hot-toast';
import { db, storage } from '@root/firebase'; // Import your Firebase config
import {
  doc,
  getDoc,
  setDoc,
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  where,
  updateDoc,
  deleteField,
} from 'firebase/firestore';
import dayjs from 'dayjs';

function CreateTribute({ menuValue, setTributeCount }) {
  const { globalUser, globalData, logout } = useAuth();
  const uploaderRef = useRef(null); // Reference for ImageUploader, allows calling its exposed functions

  const [isLoading, setIsLoading] = useState(false); // Loading state for files
  const [yourDogs, setYourDogs] = useState([]); // Dog folders
  const [selectedDog, setSelectedDog] = useState(''); // Selected dog folder
  const [selectedDogDob, setSelectedDogDob] = useState('');
  const [passingDate, setPassingDate] = useState(''); // Selected dog folder
  const [mainTitle, setMainTitle] = useState(''); // Selected dog folder
  const [subTitle, setSubTitle] = useState(''); // Selected dog folder
  const [message, setMessage] = useState(''); // Selected dog folder
  const [visbility, setVisibility] = useState('Public'); // Selected dog folder
  const [previewImage, setPreviewImage] = useState(''); // State for image preview
  const [previewPassingDate, setPreviewPassingDate] = useState(''); // State for image preview
  const [previewMainTitle, setPreviewMainTitle] = useState(''); // State for image preview
  const [previewSubTitle, setPreviewSubTitle] = useState(''); // State for image preview
  const [previewMessage, setPreviewMessage] = useState(''); // State for image preview

  useEffect(() => {
    console.log('Privacy:', visbility); // Confirm state updates
  }, [visbility]);

  useEffect(() => {
    const fetchDogLibraries = async () => {
      try {
        if (!globalUser?.uid) return;

        // Reference to the dogs subcollection
        const dogsCollectionRef = collection(
          db,
          `users/${globalUser.uid}/dogs`
        );
        const dogsSnapshot = await getDocs(dogsCollectionRef);

        if (!dogsSnapshot.empty) {
          const formattedDogs = dogsSnapshot.docs.map((doc) => {
            const dogData = doc.data();
            const dob = dogData.dob?.seconds
              ? dayjs.unix(dogData.dob.seconds).format('DD MMM YY')
              : 'Unknown'; // Format date

            return {
              dogId: doc.id, // Dog document ID
              dogName: dogData.name || 'Unknown',
              dob,
              avatar: dogData.avatar || '',
              breed: dogData.breed || '',
              sex: dogData.sex || '',
              ...dogData,
            };
          });

          setYourDogs(formattedDogs);
        } else {
          console.warn('No dog data found.');
          setYourDogs([]);
        }
      } catch (error) {
        console.error('Error fetching dog folders:', error);
        toast.error('Failed to load dog folders.');
      }
    };

    fetchDogLibraries();
  }, [globalUser?.uid]);

  const handleDogSelection = (dogName) => {
    setSelectedDog(dogName);
    const dog = yourDogs.find((dog) => dog.dogName === dogName);
    setSelectedDogDob(dog ? dog.dob : 'Unknown'); // Set the selected dog's dob
    console.log('Dog Dob: ', dog);
  };

  const handleFileSelect = (file) => {
    // Generate a temporary URL for the selected file
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setPreviewImage(previewUrl);
    } else {
      setPreviewImage('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedFile = uploaderRef.current?.getSelectedFile();

    // Validation rules
    if (!selectedFile) {
      toast.error("Please select your dog's image.");
      return;
    }

    if (!selectedDog) {
      toast.error('Please select your dog.');
      return;
    }

    if (menuValue === 'Memorial') {
      if (!passingDate) {
        toast.error('Please select a passing date.');
        return;
      }
    }

    if (!mainTitle.trim()) {
      toast.error('Main title cannot be empty.');
      return;
    }

    if (!subTitle.trim()) {
      toast.error('Sub title cannot be empty.');
      return;
    }

    if (!message.trim()) {
      toast.error('Please enter a message.');
      return;
    }

    setIsLoading(true);

    const uniqueKey = createRandomString(30);
    const memorialDocRef = doc(db, `memorials/${uniqueKey}`); // Path to Database Record - memorials/memorial or farewell or sympathy etc etc

    // Upload avatar to Firebase Storage
    const uploadedFile = await uploaderRef.current.handleUpload(
      `tributes`,
      `${uniqueKey}.jpg`,
      '',
      'memorials'
    );

    try {
      const databaseRecord = {
        fileName: `${uniqueKey}.jpg`,
        image: uploadedFile,
        tribute: menuValue,
        dog: selectedDog,
        mainTitle: mainTitle,
        subTitle: subTitle,
        message: message,
        uid: globalUser.uid,
        createdDate: new Date(),
        privacy: visbility,
        tributeId: uniqueKey,
      };

      await setDoc(memorialDocRef, databaseRecord, { merge: true });

      // Increment the tribute count
      if (setTributeCount) {
        setTributeCount((prevCount) => prevCount + 1);
      }

      toast.success('Tribute Saved.');
      setIsLoading(false);
    } catch (error) {
      console.error('Error Saving Tribute', error);
      toast.error('Failed Saving Tribute.');
      setIsLoading(false);
    }
  };

  function createRandomString(length) {
    const chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    let result = '';
    const randomArray = new Uint8Array(length);
    crypto.getRandomValues(randomArray);
    randomArray.forEach((number) => {
      result += chars[number % chars.length];
    });
    return result;
  }

  return (
    <>
      {/* Middle Side Menu Bar */}
      <div className='col-lg-5'>
        <div className='card'>
          <h5 className='card-header bg-transparent border-bottom text-uppercase'>
            Create a {menuValue}
          </h5>
          <div className='card-body'>
            <div className='row'>
              <div className='col-12'>
                <ImageUploader
                  ref={uploaderRef}
                  uid={globalData.uid}
                  onFileSelect={handleFileSelect}
                  onUpload=''
                />
              </div>
              <div className='col-6 form-floating mt-3'>
                <select
                  id='dog'
                  className='form-select'
                  onChange={(e) => handleDogSelection(e.target.value)}
                >
                  <option value=''>Select your Dog</option>
                  {yourDogs.map((dog) => (
                    <option key={dog.dogName} value={dog.dogName}>
                      {dog.dogName}
                    </option>
                  ))}
                </select>
                <label>Choose your Dog</label>
              </div>
              <div className='col-6 form-floating mt-3'>
                {menuValue === 'Memorial' ? (
                  <>
                    <input
                      className='form-control'
                      type='date'
                      onChange={(e) => {
                        setPreviewPassingDate(e.target.value),
                          setPassingDate(e.target.value);
                      }}
                    />
                    <label>Date of Passing</label>
                  </>
                ) : (
                  ''
                )}
              </div>
              <div className='col-6 form-floating mt-3'>
                <input
                  className='form-control'
                  type='text'
                  onChange={(e) => setMainTitle(e.target.value)}
                  onKeyUp={(e) => setPreviewMainTitle(e.target.value)}
                />
                <label>Main Title</label>
              </div>
              <div className='col-6 form-floating mt-3'>
                <input
                  className='form-control'
                  type='text'
                  onChange={(e) => setSubTitle(e.target.value)}
                  onKeyUp={(e) => setPreviewSubTitle(e.target.value)}
                />
                <label>Sub Title</label>
              </div>
              <div className='col-12 mt-3'>
                <ReactQuill
                  value={message}
                  onChange={(value) => {
                    setMessage(value);
                    setPreviewMessage(value);
                  }}
                />
              </div>
              <div className='col-6 form-floating mt-3'>
                <select
                  id='visbility'
                  className='form-select'
                  onChange={(e) => setVisibility(e.target.value)}
                >
                  <option value='Public'>Public Viewing</option>
                  <option value='Private'>Private Viewing</option>
                </select>
                <label>Public or Private?</label>
              </div>
              <div className='col-12 mt-3'>
                {/* Submit Button */}
                <button
                  type='button'
                  className={`btn btn-${isLoading ? 'dark' : 'primary'} waves-effect waves-light"`}
                  onClick={handleSubmit}
                >
                  {isLoading ? (
                    <>
                      <i className='bx bx-loader bx-spin font-size-16 align-middle me-2'></i>
                      Saving...
                    </>
                  ) : (
                    <>
                      <i className='bx bx-file me-1'></i> Save
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Middle Side Menu Bar */}

      {/* Right Side Menu Bar */}
      <div className='col-lg-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='row g-0 align-items-center'>
              <div className='col-md-12'>
                <div className='card-header bg-transparent border-bottom text-uppercase'>
                  <h5 className='card-title'>Preview</h5>
                  <p className='card-text'>View your tribute below..</p>
                </div>
                <div className='card-body'>
                  <div className='col-12 d-flex align-items-center'>
                    {previewImage ? (
                      <img
                        src={previewImage}
                        alt='Preview'
                        className='img-fluid rounded'
                        style={{
                          maxHeight: '300px',
                          maxWidth: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    ) : (
                      <p>No image selected.</p>
                    )}
                  </div>
                  <div className='col-12 mt-3 align-items-center'>
                    {previewMainTitle ? <h3>{previewMainTitle}</h3> : ''}
                  </div>
                  <div className='col-12 align-items-center'>
                    {previewSubTitle ? <h6>{previewSubTitle}</h6> : ''}
                  </div>
                  <div className='col-12'>
                    {previewPassingDate ? (
                      <h6>
                        Born: {} | Died: {previewPassingDate}
                      </h6>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='col-12'>
                    {previewMessage && (
                      <div
                        dangerouslySetInnerHTML={{ __html: previewMessage }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Right Side Menu Bar */}
    </>
  );
}

export default CreateTribute;
